import React, { Fragment } from "react";
import { WidgetProps } from '@rjsf/core';
import { useSchemaTranslation } from "../../../useSchemaTranslation";

export interface IInstructionUiOptions {
  href?: string;
  text?: string;
}

const InstructionWidget = (props: WidgetProps) => {
  const {
    id,
    options,
  } = props
  const { t } = useSchemaTranslation()
  const { instruction: {
    href = "",
    text = ""
  } = {} } = (options as { instruction: IInstructionUiOptions })

  const linkHref = href

  return (
    <Fragment>
      <a id={id} target="_blank" href={linkHref}>{t(text)}</a>
    </Fragment>
  );
}


export default InstructionWidget;
